import { API_URL } from "config";
import Http from "util/https";
import { CSVCountCheckCsvStock, CSVUploadCountParam, CSVUploadCountResponseApi } from "../types/index";
import { convertUTCToDate } from "../utils/common";

/**
 * 仕入先・外部倉庫用在庫一覧Api
 * @param param 在庫一覧Apiのパラメータ
 * @returns CSVCountCheckStock[]
 */
export default async function getCsvConfirmApi(param: CSVUploadCountParam) {
  const http = Http.default.alterAuth({ useToken: true, useFormData: true });
  const url = `${API_URL}/stock/csv/upload`;
  const res = await http.post<CSVUploadCountResponseApi>(url, Http.convertObjectToFormData(param));

  // const res: {data: CSVUploadCountResponseApi} = {data: {
  //   total: 10,
  //   process_id: "1",
  //   errors: ["errors1", "errors2", "errors3","errors1", "errors2", "errors3","errors1", "errors2", "errors3","errors1", "errors2", "errors3"],
  //   list: [
  //   {
  //     item_cd: "item_cd",
  //     jan_cd: "jan",
  //     quantity: 1,
  //     arrival_date: "2025/10/24",
  //     vendor_cd: "000001",
  //     depot_cd: "0000001",
  //     vendor_name: "",
  //     depot_name: "",
  //     depot_kind: false,
  //     error: "error"
  //   }
  // ]}}

  const stocks: CSVCountCheckCsvStock[] = res.data.list.map((s, index) => {
    const stock: CSVCountCheckCsvStock = {
      id: `${index}`,
      productCd: s.item_cd,
      JANCd: s.jan_cd,
      amount: s.quantity,
      arrivalDate: convertUTCToDate(s.arrival_date),
      supplierCd: s.vendor_cd,
      warehouseCd: s.depot_cd,
      supplierName: s.vendor_name,
      warehouseName: s.depot_name,
      isCenter: !s.depot_kind,
      // supplierWarehouses: s.depot_stocks.map((d) => ({
      //   name: d.depot_name,
      //   code: d.depot_cd,
      //   amount: d.quantity,
      //   isCenter: !d.depot_kind,
      // })),
      error: s.error ?? undefined,
    };
    // 仕入先の場合、倉庫コードあり
    if ('depot_cd' in s && s.depot_cd) {
      stock.warehouseCd = s.depot_cd;
      stock.warehouseName = s.depot_name;
    }

    return stock;
  });

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  console.log(res);
  console.log(stocks);
  return {
    stocks,
    processId: res.data.process_id,
    total: res.data.total,
    // error: res.data.list.some((s) => s.error)
    //   ? "エラーがあります。修正してからもう一度アップロードしてください。"
    //   : undefined,
    error: (res.data.errors && res.data.errors.length > 0) ? `${res.data.errors.slice(0,10).join('\n')}${res.data.errors.length > 10 ? `（その他${res.data.errors.length - 10}件）` : ""}` : undefined,
  };
}
